import { ListingEditorVariantPage } from "@/components/listing-editor";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/listings/$listingId/$version/variants/$variantId")({
  component: Page,
});

function Page() {
  const { variantId } = Route.useParams();
  return <ListingEditorVariantPage variantId={variantId} />;
}
